import { getTagsSuggetions, IJobTag } from 'wisestep-api';
import { WsAutocompleteInput } from 'wisestep-base';

import { transformIJobTagsToStringArray } from '../../../features/jobs/helper';
import WsFilterProps from '../models/WsFilterProps';

const WsTagsFilter = ({
  name,
  placeHolder = 'Enter Tags, comma seperated',
  label = 'Tags',
  options,
}: WsFilterProps) => (
  <WsAutocompleteInput
    name={name}
    options={options ?? []}
    placeholder={placeHolder}
    freeSolo={true}
    multiple={true}
    label={label}
    getOptions={async (query: string) => {
      const result: IJobTag[] | any = await getTagsSuggetions(query);
      return transformIJobTagsToStringArray(result.data) ?? [];
    }}
  />
);

export default WsTagsFilter;
